export const CalMiniCalendar = {
  flow: 'y',
  padding: 'A',
  gap: 'Z1',
  userSelect: 'none',

  Header: {
    flow: 'x',
    align: 'center space-between',
    marginBottom: 'Z1',

    Label: {
      tag: 'span',
      fontSize: 'Z2',
      fontWeight: '600',
      color: 'title',
      text: (el, s) => {
        const root = s.root
        return el.call('getMonthLabel', root.currentYear, root.currentMonth)
      }
    },

    NavBtns: {
      flow: 'x',
      gap: 'Z',

      PrevBtn: {
        extends: 'IconButton',
        Icon: { icon: 'arrowAngleLeft' },
        onClick: (e, el, s) => {
          const root = s.root
          const { year, month } = el.call(
            'prevMonth',
            root.currentYear,
            root.currentMonth
          )
          root.update({ currentYear: year, currentMonth: month })
        }
      },

      NextBtn: {
        extends: 'IconButton',
        Icon: { icon: 'arrowAngleRight' },
        onClick: (e, el, s) => {
          const root = s.root
          const { year, month } = el.call(
            'nextMonth',
            root.currentYear,
            root.currentMonth
          )
          root.update({ currentYear: year, currentMonth: month })
        }
      }
    }
  },

  DayLabels: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    marginBottom: 'Z',

    childExtends: 'CalMiniDayLabel',
    childrenAs: 'state',
    children: (el) => el.call('getDayNames').map((d) => ({ label: d[0] }))
  },

  Grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '2px',

    childExtends: 'CalMiniDayCell',
    childrenAs: 'state',
    children: (el, s) => {
      const root = s.root
      return el.call('getMonthDays', root.currentYear, root.currentMonth)
    }
  }
}

export const CalMiniDayLabel = {
  align: 'center center',
  padding: 'Z 0',
  fontSize: 'Y2',
  fontWeight: '600',
  color: 'caption',
  text: (el, s) => s.label || ''
}

export const CalMiniDayCell = {
  tag: 'button',
  align: 'center center',
  padding: '0',
  width: 'B',
  height: 'B',
  round: '50%',
  fontSize: 'Y2',
  fontWeight: '500',
  border: 'none',
  cursor: 'pointer',
  background: (el, s) => {
    const root = el.state.root
    if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day))
      return 'blue'
    if (
      !s.isOtherMonth &&
      root.currentDay === s.day &&
      root.currentMonth === s.month
    )
      return 'selectedDay'
    return 'transparent'
  },
  color: (el, s) => {
    if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day))
      return 'white'
    return s.isOtherMonth ? 'caption' : 'title'
  },
  opacity: (el, s) => (s.isOtherMonth ? '.4' : '1'),
  ':hover': { background: 'overlay' },
  text: (el, s) => String(s.day),
  onClick: (e, el, s) => {
    const root = el.state.root
    root.update({
      currentDay: s.day,
      currentMonth: s.month,
      currentYear: s.year
    })
  }
}
